export default "__VITE_ASSET__CsB6_FEP__"